import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@bb-ui/react-library/dist/components/styles';
import { SearchBox } from '@bb-ui/react-library/dist/components/SearchBox';
import { TextField } from '@bb-ui/react-library/dist/components/TextField';
import { useTranslation } from 'react-i18next';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(4),
    },
    searchBox: {
      maxWidth: 400,
    },
    textField: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    label: {
      marginBottom: 0,
      marginRight: theme.spacing(1),
      fontWeight: theme.typography.fontWeightRegular,
    },
    searchForm: {
      display: 'flex',
      flex: 1,
      marginRight: theme.spacing(2),
    },
  }),
);

interface ClientsTableToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: (value: string) => void;

  pageSize: number;
  onPageSizeChange: (value: number) => void;
  pageSizeOptions: number[];

  searchLabel: string;
}

export const ClientsTableToolbar: React.FC<ClientsTableToolbarProps> = ({
  searchValue,
  onSearchChange,
  onSearchSubmit,
  pageSize,
  onPageSizeChange,
  pageSizeOptions,
  searchLabel,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = searchValue.trim();
    if (value) {
      onSearchSubmit(value);
    }
  };

  return (
    <div className={classes.toolbar}>
      <form className={classes.searchForm} onSubmit={handleSubmit}>
        <SearchBox
          className={classes.searchBox}
          label={searchLabel}
          inputId="paginated-table-search-input"
          value={searchValue}
          onChange={onSearchChange}
        />
      </form>

      <TextField
        select
        className={classes.textField}
        id="paginated-table-items-per-page"
        label={t('global.itemsPerPage')}
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        SelectProps={{ native: true }}
        InputLabelProps={{ className: classes.label }}
        data-testid="paginated-table-items-per-page"
      >
        {pageSizeOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </TextField>
    </div>
  );
};

export default ClientsTableToolbar;
